import { Component, signal } from '@angular/core';

import { of } from 'rxjs';

import { FormComponent } from '@camelot/form-basic';
import {
  CheckboxComponent,
  DropdownComponent,
  RadioComponent,
  SearchFieldComponent,
  TextBoxComponent,
  TextareaComponent,
  ToggleComponent,
} from '@camelot/form-input';
import { InputCheckBox, InputDropdown, CamAbstractInput, InputRadio, InputTextBox, InputTextarea } from '@camelot/form-model';

import { TestIdDirective } from '@camelot/testing-harness';

@Component({
    imports: [
        CheckboxComponent,
        DropdownComponent,
        FormComponent,
        RadioComponent,
        SearchFieldComponent,
        TestIdDirective,
        TextBoxComponent,
        TextareaComponent,
        ToggleComponent,
    ],
    template: `
    <cam-input-textbox camTestId="it-textbox" [input]="this.textbox" [standalone]="true" />
    <div camTestId="it-textbox-value">{{ this.textboxValue() }}</div>

    <cam-input-textarea camTestId="it-textarea" [input]="this.textarea" [standalone]="true" />
    <div camTestId="it-textarea-value">{{ this.textareaValue() }}</div>

    <cam-input-checkbox camTestId="it-checkbox" [input]="this.checkbox" [standalone]="true" />
    <div camTestId="it-checkbox-value">{{ this.checkboxValue() }}</div>

    <cam-input-toggle camTestId="it-toggle" [input]="this.toggle" [standalone]="true" />
    <div camTestId="it-toggle-value">{{ this.toggleValue() }}</div>

    <cam-input-dropdown camTestId="it-dropdown" [input]="this.dropdown" [standalone]="true" />
    <div camTestId="it-dropdown-value">{{ this.dropdownValue() }}</div>

    <cam-input-radio camTestId="it-radio" [input]="this.radio" [standalone]="true" />
    <div camTestId="it-radio-value">{{ this.radioValue() }}</div>

    <cam-search-field camTestId="it-search" [input]="this.search" />
    <div camTestId="it-search-value">{{ this.searchValue() }}</div>

    <cam-form camTestId="it-form" [inputs]="this.formInputs" (valid)="this.onValid($event)" />
    <div camTestId="it-form-submitted">{{ this.submitted() }}</div>
  `
})
export class FormInteractionsCase {
  public checkbox = new InputCheckBox({ key: 'checkbox', label: 'Checkbox' });
  public checkboxValue = signal('');
  public dropdown = new InputDropdown<string>({
    key: 'dropdown',
    label: 'Dropdown',
    options: of([
      { id: '1', name: 'Option one' },
      { id: '2', name: 'Option two' },
    ]),
  });
  public dropdownValue = signal('');
  public formInputs: CamAbstractInput[] = [new InputTextBox({ key: 'name', label: 'Name' })];
  public radio = new InputRadio<string>({
    key: 'radio',
    label: 'Radio',
    options: of([
      { id: 'a', name: 'Choice A' },
      { id: 'b', name: 'Choice B' },
    ]),
  });
  public radioValue = signal('');
  public search = new InputTextBox({ key: 'search', label: 'Search' });
  public searchValue = signal('');
  public submitted = signal('');
  public textarea = new InputTextarea({ key: 'textarea', label: 'Textarea' });
  public textareaValue = signal('');
  public textbox = new InputTextBox({ key: 'textbox', label: 'Textbox' });
  public textboxValue = signal('');
  public toggle = new InputCheckBox({ key: 'toggle', label: 'Toggle', toggle: true });
  public toggleValue = signal('');

  ngOnInit(): void {
    this.textbox.changeValue$.subscribe(value => this.textboxValue.set(String(value ?? '')));
    this.textarea.changeValue$.subscribe(value => this.textareaValue.set(String(value ?? '')));
    this.checkbox.changeValue$.subscribe(value => this.checkboxValue.set(String(value)));
    this.toggle.changeValue$.subscribe(value => this.toggleValue.set(String(value)));
    this.dropdown.changeValue$.subscribe(value => this.dropdownValue.set(JSON.stringify(value)));
    this.radio.changeValue$.subscribe(value => this.radioValue.set(String(value ?? '')));
    this.search.changeValue$.subscribe(value => this.searchValue.set(String(value ?? '')));
  }

  public onValid(data: unknown): void {
    this.submitted.set(JSON.stringify(data));
  }
}
